import React, { Component } from "react";
import { connect } from "react-redux";
import { Container } from "reactstrap";

import "./style.css";
import historyActions from "../../redux/history/action";
import contactUsActions from "../../redux/contactUs/action";
import PageHead from "../../component/pageHead/PageHead";
import api from "../../config/api";
import CustomLoader from "../../component/CustomLoader/CustomLoader";

class ContactUs extends Component {
  state = {
    info: "",
    showLoader: false
  };

  componentDidMount() {
    const { info } = this.props;

    if (!info) {
      this.fetchInfo();
    }
  }

  fetchInfo = async () => {
    const { history, setHistory, setContactDetails } = this.props;

    this.setState({ showLoader: true });

    const response = await api.contactInfo();

    setContactDetails(response.data.result);
    
    this.setState({
      info: response.data.result,
      showLoader: false
    });

    setHistory(history);
  };

  render() {
    const { showLoader } = this.state;
    const { info } = this.props;

    return (
      <Container>
        <PageHead containerStyles={{ width: "100%" }} title="CONTACT US" />
        {info && (
          <div>
            <div className="contact-us-container">
              <img alt="map" src={require("../../assets/icons/Map.svg")} />
              <p>{info.address}</p>
            </div>
            <div className="contact-us-container">
              <img alt="mail" src={require("../../assets/icons/Mail.svg")} />
              <p>{info.email}</p>
            </div>
            <div className="contact-us-container">
              <img alt="phone" src={require("../../assets/icons/Phone.svg")} />
              <p>
                {info.phone}, {info.Tel}
              </p>
            </div>
            <div className="contact-us-map-container">
              <img alt="map" src={require("../../assets/icons/map.png")} />
            </div>
          </div>
        )}
        {showLoader && <CustomLoader loadingText="Fetching Info" />}
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth.user,
  info: state.contactUs.info
});

const mapDispatchToProps = {
  setHistory: historyActions.setHistory,
  setContactDetails: contactUsActions.setContactDetails
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContactUs);
